import StreetAddress from 'app/shared/model/StreetAddress';

const ClaimListing = ({
    listingAlias = '',
    feedName = '',
    address = {},
    photoUrl = '',
    isActive = null,
    status = '',
    contactEmail,
    contactPhone,
} = {}) => ({
    listingAlias: String(listingAlias),
    feedName: String(feedName),
    address: new StreetAddress(address),
    photoUrl: String(photoUrl),
    isActive: Boolean(isActive),
    status: String(status),
    contactEmail: String(contactEmail),
    contactPhone: String(contactPhone),
});

export default ClaimListing;
